import { render } from "./RestrictionsModal.vue?vue&type=template&id=64c06091&scoped=true"
import script from "./RestrictionsModal.vue?vue&type=script&lang=js"
export * from "./RestrictionsModal.vue?vue&type=script&lang=js"

import "./RestrictionsModal.vue?vue&type=style&index=0&id=64c06091&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/wbtank/wbtank-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c06091"]])

export default __exports__